import { render, staticRenderFns } from "./Uon.vue?vue&type=template&id=046cb0d8&"
import script from "./Uon.vue?vue&type=script&setup=true&lang=js&"
export * from "./Uon.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Uon.vue?vue&type=style&index=0&id=046cb0d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports